const TIME_PRESETS = [
  { value: '6:0',   hours: 6,  minutes: 0  },
  { value: '9:0',   hours: 9,  minutes: 0  },
  { value: '12:0',  hours: 12, minutes: 0  },
  { value: '15:0',  hours: 15, minutes: 0  },
  { value: '18:30', hours: 18, minutes: 30 },
  { value: '20:0',  hours: 20, minutes: 0  },
  { value: '22:0',  hours: 22, minutes: 0  },
];

export class TimeControlsUI {
  constructor(sceneManager, app) {
    this.sceneManager = sceneManager;
    this.app = app;
    this.timeManager = null;
    this.presetSelect = null;
    this.saveStateTimeout = null;
  }

  init() {
    this.timeManager = this.sceneManager.getTimeManager();
    if (!this.timeManager) {
      console.warn('TimeManager not found in SceneManager');
      return;
    }

    this.presetSelect = document.getElementById('time-preset-select');
    if (this.presetSelect) {
      this.presetSelect.addEventListener('change', (e) => {
        const [h, m] = e.target.value.split(':').map(Number);
        this.timeManager.setTime(h, m);
        this._saveDebounced();
      });
    }

    this.update();
  }

  update() {
    if (!this.timeManager || !this.presetSelect) return;
    const h = this.timeManager.getHours();
    const m = this.timeManager.getMinutes();
    const currentMinutes = h * 60 + m;

    let bestVal = TIME_PRESETS[0].value;
    let bestDiff = Infinity;
    for (const p of TIME_PRESETS) {
      const diff = Math.abs(p.hours * 60 + p.minutes - currentMinutes);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestVal = p.value;
      }
    }
    this.presetSelect.value = bestVal;
  }

  _saveDebounced() {
    clearTimeout(this.saveStateTimeout);
    this.saveStateTimeout = setTimeout(() => {
      this.app?.getStateManager()?.saveSceneState();
    }, 500);
  }
}
